"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Grid_1 = require("@material-ui/core/Grid");
var Typography_1 = require("@material-ui/core/Typography");
var withStyles_1 = require("@material-ui/styles/withStyles");
var CartItem_1 = require("./CartItem");
var styles_1 = require("./styles");
var Cart = function (props) {
    var _a;
    var classes = props.classes, cart = props.cart, onRemoveClick = props.onRemoveClick;
    if (!cart) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid_1.default, { item: true, className: classes.cartGridItem },
            React.createElement(Typography_1.default, { variant: "h5" }, "Cart")), (_a = cart.lineItems) === null || _a === void 0 ? void 0 :
        _a.map(function (lineItem) { return (lineItem == null ? null : (React.createElement(CartItem_1.default, { key: "cart-item-" + lineItem.variantId, lineItem: lineItem, onRemoveClick: onRemoveClick }))); })));
};
exports.default = withStyles_1.default(styles_1.default)(Cart);
